<template>
  <b-modal
    ref="valueModal"
    size="md"
    hide-footer
    :title="$t('diagnosis.labels.valueUnitInfo')"
    centered
    modal-class="value-modal"
  >
    <b-row class="mx-1">
      <b-col>
        <div class="info-card d-flex flex-column justify-content-center align-items-center">
          <small>{{ $t('diagnosis.labels.valueUnitCase') }}</small>
          <span><strong>{{ totalURV || 0 }}</strong></span>
        </div>
      </b-col>
    </b-row>
    <b-row class="mx-1">
      <b-col>
        <hr>
      </b-col>
    </b-row>
    <div class="scroll-unit">
      <b-row class="mx-1 sticky">
        <b-col>
          <div class="header p-1">
            <b-row>
              <b-col cols="2" />
              <b-col>
                <span>{{ $tc('global.sample',2) }}</span>
              </b-col>
              <b-col>
                <span>{{ $tc('global.technique',2) }}</span>
              </b-col>
              <b-col>
                <span><strong>{{ $t('diagnosis.modals.total') }}</strong></span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-for="(valueUnit, index) in valueUnits"
        :key="index"
        class="mx-1 mt-1"
      >
        <b-col>
          <div class="unit-row p-1">
            <b-row>
              <b-col cols="2">
                <span class="ml-3 primary-dark-color font-weight--medium">{{ valueUnit.samplenumber }}</span>
              </b-col>
              <b-col>
                <span>{{ valueUnit.sampleUrv }}</span>
              </b-col>
              <b-col>
                <span>{{ valueUnit.totalSampleSubportionsUrv }}</span>
              </b-col>
              <b-col>
                <span><strong>{{ valueUnit.totalSampleUrv }}</strong></span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

import valuableConceptResource from '@/api/resources/ValuableConceptResource'

export default {
    name: 'ValueUnitModal',
    props: {
        laboratoryId: Number,
        caseId: Number,
        patientId: Number,
        totalURV: Number
    },
    data() {
        return {
            valueUnits: []
        }
    },
    methods: {
        async show() {
            this.updateLoading(true)
            const [err, response] = await this.toCall(valuableConceptResource.findURVValuableConceptAppliedByCase(this.laboratoryId, this.caseId))
            this.updateLoading(false)

            if (err) {
                this.showErrorModalGlobal()
                return
            }

            this.valueUnits = response
            this.$refs.valueModal.show()
        },
        hide() {
            this.valueUnits = []
            this.$refs.valueModal.hide()
        }
    }
}
</script>

<style lang="scss">
.value-modal .main{
  color: vt-color(primary) !important;
}

.value-modal .modal-body{
  padding-bottom: 40px;
}

.value-modal .table-bordered thead th,
.table-bordered thead td {
  font-weight: normal;
  text-transform: uppercase;
  font-size: font-size(small);
  color: vt-color(base-text);
}

.value-modal .info-card {
  border: 1px solid vt-color(light-grey);
  height: 60px;
  line-height: 16px;
  box-shadow: 0 2px 5px 0 #9c9c9c;
}

.value-modal .info-card small {
  text-transform: uppercase;
  font-size: font-size(very-tiny);
}

.value-modal .info-card span {
  color: vt-color(dark-text);
  font-size: font-size(normal);
  text-align: center;
}

.value-modal .header{
  background: vt-color(light-grey-alt);
  border-radius: 3px;
}

.value-modal .header span{
  text-transform: uppercase;
  font-size: font-size(small);
  color: vt-color(dark-text);
}

.value-modal .unit-row{
  border-bottom: 1px solid vt-color(base-text, .7);
  transition: .4s;
  background-color: vt-color(primary, 1);
}

.value-modal .unit-row:hover{
  background-color: vt-color(primary, .95);
}

.value-modal .scroll-unit{
  min-height: 20vh;
  max-height: 30vh;
  overflow-y: auto;
}

.value-modal .sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
}

</style>
